import type { DeepRequired } from '../fixtures.types'

const dip: DeepRequired<Dip> = {
  __typename: 'Dip',
  additional_fields_required: [],
  dip_available: true,
  messages: [],
  mortgage_id: null,
  permanent: true,
  reason: null,
  supports_dip_certificate: true,
}

export default dip
